import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';
import { ThemeProps } from '../../../types';
import { storageBucket, textReplacer } from '../../../utils';

export interface CardProps {
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
  /**
   * The react child to render
   */
  children: ReactNode;
}

const Card = ({ children, className }: CardProps) => {
  const location = useLocation();
  const theme: ThemeProps = useTheme();
  const heroImageUrl = theme.images?.hero
    ? textReplacer(theme.images?.hero, {
        '{STORAGE_BUCKET}': storageBucket,
      })
    : '';

  return (
    <main className={className}>
      {location.pathname.includes('plan-selector') && (
        <img alt='Hero' className='hero-img' src={heroImageUrl as string} />
      )}
      <section className='page-section'>{children}</section>
    </main>
  );
};

const StyledCard = styled((props: any) => <Card {...props} />)`
  ${({ theme }: { theme: ThemeProps }) => ({
    backgroundColor: theme.colors.background.paper,
    borderRadius: 0,
    boxShadow: 'none',
    margin: '0 auto',
    maxWidth: 600,
    position: 'relative',
    width: '100%',
    [theme.mq.desktop]: {
      borderRadius: theme.radii.card,
      boxShadow: theme.shadows.card,
    },
    '.hero-img': {
      width: '100%',
      [theme.mq.desktop]: {
        borderTopLeftRadius: theme.radii.card,
        borderTopRightRadius: theme.radii.card,
      },
    },
    '.page-section': {
      paddingBottom: 24,
      paddingLeft: 16,
      paddingRight: 16,
      paddingTop: 48,
      [theme.mq.desktop]: {
        paddingLeft: 40,
        paddingRight: 40,
      },
    },
  })}
`;

export default StyledCard;
